import React from 'react';

import { Icon, useTranslation } from '@testsigma/atoms';

import { DocumentURL } from '@utils/common';

import { useSFConnectionState } from '@contexts/sf-connection-context';

const ConnectionFormHeader: React.FC = () => {
  const { t } = useTranslation();
  const { selectedConnection } = useSFConnectionState();

  return (
    <div className='flex items-center justify-between h-[60px]'>
      <div className='flex items-center'>
        <div className='ml-8 mr-2 items-center my-4 font-medium text-[18px] text-secondary-unique-600'>
          {selectedConnection?.id
            ? t('user.connection.label.update')
            : t('user.connection.label.add')}
        </div>
        <DocumentURL path='/docs/salesforce-testing/introduction/'>
          <Icon
            name='help'
            toolTip={t('connection.help.tooltip')}
            className='flex items-center text-secondary-400 hover:text-secondary-500'
          />
        </DocumentURL>
      </div>
      <DocumentURL
        path='/docs/salesforce-testing/user-connections/'
        label='add-connection.info.link'
        className='mr-5 items-center my-4 text-sm'
      />
    </div>
  );
};

export { ConnectionFormHeader };
